/**
 *  All api related to Favourites
 */

import _ from 'lodash'
import { CancelToken } from 'axios'
import { OmnitechApi } from '../../api'
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function validatePhone({
  phone = '',
  params = {},
  payload = {},
  ...otherOptions
}) {
  const source = CancelToken.source()
  cancelRequest.add(
    'validatePhone',
    () => source.cancel('validatePhone: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: 'phones/formatter',
      method: 'post',
      params,
      data: {
        data: {
          phone: { phone }
        },
        ...payload
      },
      cancelToken: source.token,
      ...otherOptions
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      phone: data.phone
    }))
}
